export const STATUSES = {
  NEW: 'new',
  NEED_RESPONSE: 'need_response',
  PENDING: 'pending',
  CLOSED: 'closed',
  DRAFT: 'draft',
  BOOKED: 'booked',
  NOT_BOOKED: 'not_booked',
  REJECTED: 'rejected',
  DECLINED: 'declined',
  VIEWED: 'viewed',
  CANCELLED: 'cancelled',
  EXPIRED: 'expired',
  DELETED: 'deleted',
  ACTION_REQUIRED: 'action_required',
};
export const STATUS_ICONS = {
  [STATUSES.NEW]: 'mdi-new-box',
  [STATUSES.NEED_RESPONSE]: 'mdi-bell-ring-outline',
  [STATUSES.PENDING]: 'mdi-timer-pause-outline',
  [STATUSES.CLOSED]: 'mdi-lock',
  [STATUSES.DRAFT]: 'mdi-file-document-edit-outline',
  [STATUSES.BOOKED]: 'mdi-checkbox-marked-circle-outline',
  [STATUSES.NOT_BOOKED]: 'mdi-cancel',
  [STATUSES.REJECTED]: 'mdi-undo-variant',
  [STATUSES.DECLINED]: 'mdi-archive',
  [STATUSES.VIEWED]: 'mdi-eye',
  [STATUSES.CANCELLED]: 'mdi-cancel',
  [STATUSES.EXPIRED]: 'mdi-clock',
  [STATUSES.DELETED]: 'mdi-delete',
  [STATUSES.ACTION_REQUIRED]: 'mdi-alert-circle-outline',
};
export const STATUS_COLORS = {
  [STATUSES.NEW]: 'success',
  [STATUSES.NEED_RESPONSE]: 'warning',
  [STATUSES.PENDING]: 'warning',
  [STATUSES.CLOSED]: 'silver-chalice',
  [STATUSES.DRAFT]: 'error',
  [STATUSES.BOOKED]: 'success',
  [STATUSES.NOT_BOOKED]: 'silver-chalice',
  [STATUSES.REJECTED]: 'error',
  [STATUSES.DECLINED]: 'silver-chalice',
  [STATUSES.VIEWED]: 'silver-chalice',
  [STATUSES.CANCELLED]: 'error',
  [STATUSES.EXPIRED]: 'silver-chalice',
  [STATUSES.DELETED]: 'silver-chalice',
  [STATUSES.ACTION_REQUIRED]: 'warning',
};

// Statuses where a deadline is still "live" — the request/quote is awaiting the customer's
// action, so the deadline urgency treatment (#622) is meaningful. Any other status is terminal
// (booked, rejected, expired, cancelled, …): the item is already handled, its deadline never
// actually lapsed against anyone, so urgency must not be shown for it.
export const DEADLINE_ACTIONABLE_STATUSES = [
  STATUSES.NEW,
  STATUSES.NEED_RESPONSE,
  STATUSES.PENDING,
  STATUSES.VIEWED,
  STATUSES.ACTION_REQUIRED,
];

export function isDeadlineActionable(status) {
  return DEADLINE_ACTIONABLE_STATUSES.includes(status);
}
